import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment';
import { END_DATE, START_DATE } from 'Root/archive-search/actions';
import { connect } from 'react-redux';
import { triggerSearch, clearSearchTerm } from 'Root/archive-search/actions';
import DateRangeFilterMoment
	from 'Root/archive-search/components/filters/date-range-filter-moment';

class FilterSideBar extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			showDateFilters         : false,
			showChronologicalFilters: true,
			isChronological         : true,
			date                    : 'all',
			searchTerm              : '',
			showSubCategories       : true
		};
		this.debounceTimeout = null; // Timeout ID for debouncing
		this.toggleDateFilters = this.toggleDateFilters.bind( this );
		this.toggleChronologicalFilter = this.toggleChronologicalFilter.bind( this );
		this.toggleChronologicalPopularFilter = this.toggleChronologicalPopularFilter.bind( this );
		this.setDateFilter = this.setDateFilter.bind( this );
		this.handleSearchChange = this.handleSearchChange.bind( this );
		this.toggleShowSubCategories = this.toggleShowSubCategories.bind( this );
		this.clearSearchFilters = this.clearSearchFilters.bind( this );
	}

	handleChangeStart( date ) {
		this.props.dispatch( {
			                     type: START_DATE, payload: date
		                     } );
	}

	handleChangeEnd( date ) {
		this.props.dispatch( {
			                     type: END_DATE, payload: date
		                     } );
	}

	toggleDateFilters() {
		this.setState( ( prevState ) => ({
				showDateFilters: !prevState.showDateFilters
			}
		) );
	}

	toggleChronologicalFilter() {
		this.setState( ( prevState ) => ({
				showChronologicalFilters: !prevState.showChronologicalFilters
			}
		) );
	}

	toggleChronologicalPopularFilter() {
		this.setState( ( prevState ) => ({
				isChronological: !prevState.isChronological
			}
		) );
	}

	toggleShowSubCategories() {
		this.setState( ( prevState ) => ({
				showSubCategories: !prevState.showSubCategories
			}
		) );
	}

	setDateFilter( filter ) {
		this.setState( ( prevState ) => ({
				date: filter.value
			}
		) );
		if ( filter.value !== 'all' && filter.value !== 'range' ) {
			this.handleChangeStart( filter.start );
			this.handleChangeEnd( filter.end );
		} else {
			this.handleChangeStart( '' );
			this.handleChangeEnd( '' );
		}
	}

	setSearch( searchTerm ) {
		this.props.dispatch( triggerSearch( searchTerm ) ); // Ensure the action is dispatched
	}

	handleSearchChange( event ) {
		const searchTerm = event.target.value;
		this.setState( { searchTerm } );

		// Clear the previous timeout
		if ( this.debounceTimeout ) {
			clearTimeout( this.debounceTimeout );
		}

		// Set a new timeout to trigger the search after 1 second
		this.debounceTimeout = setTimeout( () => {
			this.setSearch( searchTerm );
		}, 500 ); // 1000ms = 1 second
	}

	getTopLevelCategoryDetails( topLevelCategory ) {
		return ISDA_Main.categories.find( ( category ) => category.slug === topLevelCategory );
	}

	getSubCategoryDetails( topLevelCategory_id ) {
		return ISDA_Main.categories.filter( ( category ) => category.parent === topLevelCategory_id );
	}

	handleCheckboxChange( subCategoryId, clearFilters = false ) {
		const topLevelCategoryDetails = this.getTopLevelCategoryDetails( this.props.topLevelCategory );
		const params = new URLSearchParams( this.props.location.search );
		const currentCategories = params.get( 'subcategories' )
		                          ? params.get( 'subcategories' ).split( ',' )
		                          : [];
		if ( String( subCategoryId ) === String( topLevelCategoryDetails.term_id ) ) {
			this.props.onCheckboxChange( [] , clearFilters );
			return;
		}

		let updatedCategories;
		if ( currentCategories.includes( String( subCategoryId ) ) ) {
			updatedCategories = currentCategories.filter( ( category ) => category !== String( subCategoryId ) );
		} else {
			updatedCategories = [...currentCategories, String( subCategoryId )];
		}

		if ( updatedCategories.length === 0 || (updatedCategories.length === topLevelCategoryDetails.children.length) ) {
			this.props.onCheckboxChange( [] , clearFilters );
		} else {
			this.props.onCheckboxChange( updatedCategories, clearFilters );
		}
	}

	renderSubcategoryButtons() {
		if ( typeof this.props.topLevelCategory !== 'undefined' ) {
			const topLevelCategoryDetails = this.getTopLevelCategoryDetails( this.props.topLevelCategory );
			const subCategoriesDetails = this.getSubCategoryDetails( topLevelCategoryDetails.term_id );
			const params = new URLSearchParams( this.props.location.search );
			const currentCategories = params.get( 'subcategories' )
			                          ? params.get( 'subcategories' )
			                                  .split( ',' )
			                          : [];
			const defaultChecked = currentCategories.length === 0;
			return (<div>
                <div className="filter-checkbox-container"
                     onClick={ !this.props.loading ? () => this.handleCheckboxChange( topLevelCategoryDetails.term_id ) : undefined }>
                    <label className={ 'custom-checkbox' }
                           htmlFor={ `checkbox-all` }
                    >
                        <input
                            type="checkbox"
                            id={ `checkbox-all` }
                            className={ `${ currentCategories.length === 0 ? 'active' : '' }` }
                            checked={ defaultChecked }
                            name={ 'select-subcategory' }
                            disabled={ this.props.loading }
                        />
                        <span className="checkmark"/>
                    </label>
						<label
							htmlFor={ `checkbox-all` }
							dangerouslySetInnerHTML={ { __html: 'All' } }
						/>

					</div>
					{ subCategoriesDetails.map( ( subCategory, i ) => {
                    const isChecked = currentCategories.includes( String( subCategory.term_id ) );

                    return (<div key={ i }
                                className="filter-checkbox-container"
                                onClick={ !this.props.loading ? () => this.handleCheckboxChange( subCategory.term_id ) : undefined }>
                            <label className={ 'custom-checkbox' }
                                   htmlFor={ `checkbox-${ subCategory.term_id }` }
                            >
                                <input
                                    type="checkbox"
                                    id={ `checkbox-${ subCategory.term_id }` }
                                    className={ `${ isChecked ? 'active' : '' }` }
                                    name={ 'select-subcategory' }
                                    checked={ isChecked }
                                    onChange={ () => this.handleCheckboxChange( subCategory.term_id ) }
                                    disabled={ this.props.loading }
                                />
                                <span className="checkmark"/>
                            </label>
								<label
									htmlFor={ `checkbox-${ subCategory.term_id }` }
									dangerouslySetInnerHTML={ { __html: subCategory.name } }
								/>
							</div>
						);
					} ) }
				</div>
			);
		}
	}

	renderMainCategories() {
		return (<div className="" role="group" aria-label="Category Filter">
				{ ISDA_Main.policy_categories.map( ( category, index ) => {
					const isCurrentCategory = this.props.currentCategorySlug === category.slug;
					return (<div key={ index }
					             className="filter-category-main-container">
							{ !isCurrentCategory && (<a
									href={ `/category/${ category.slug }/` }
									className={ `filter-category-header category-link ${ category.slug } ${ this.props.currentCategorySlug === category.slug
									                                                                        ? 'active'
									                                                                        : '' }` }
								>
									<b>{ category.name }</b>
									<span
										className="category-count"></span>
									<i className="fa-solid fa-arrow-right arrow-icon"></i>
								</a>
							) }
							{ isCurrentCategory && (
								<div className={ 'filter-category-header' }>
									<b className={ 'current-category' }>{ category.name }</b>
									<span
										className="category-count"></span>
									{ category.slug !== 'all' && (<i onClick={ this.toggleShowSubCategories }
									   className={ `fa-solid fa-chevron-${ this.state.showSubCategories 
									                                       ? 'up'
									                                       : 'down' } filter-toggle-icon` }></i>
									) }
								</div>
							) }
							{ ((this.props.topLevelCategory === category.slug
								) && this.state.showSubCategories && category.slug !== 'all'
							  ) && this.renderSubcategoryButtons() }
						</div>
					);
				} ) }
			</div>
		);
	}

	getDateFilters() {
		const dateFilters = [
			{ name: 'All', value: 'all' }, {
				name : 'This Week',
				value: 'week',
				start: moment().startOf( 'week' ),
				end  : moment().endOf( 'week' )
			}, {
				name : 'This Month',
				value: 'month',
				start: moment().startOf( 'month' ),
				end  : moment().endOf( 'month' )
			}, {
				name : 'This Year',
				value: 'year',
				start: moment().startOf( 'year' ),
				end  : moment().endOf( 'year' )
			}, {
				name : 'Date range',
				value: 'range',
				start: moment().startOf( 'year' ),
				end  : moment().endOf( 'year' )
			}
		];
		return (<div>
				<hr className={ 'category-divider' }/>
				<div className={ 'filter-heading-container' }>
					<h3 className="filter-heading">Date</h3>
					<i
						className={ `fa-solid fa-chevron-${ this.state.showDateFilters
						                                    ? 'up'
						                                    : 'down' } filter-toggle-icon` }
						onClick={ this.toggleDateFilters }
					/>
				</div>
				{ this.state.showDateFilters && dateFilters.map( ( filter, index ) => {
					return (<div key={ index }
					             onClick={ () => this.setDateFilter( filter ) }
					             className="filter-radio-button-container">
							<div className={ 'custom-radio' }>
								<input type="radio"
								       id={ `checkbox-${ filter.value }` }
								       className={ `custom-checkbox` }
								       checked={ filter.value === this.state.date }
								/>
								<label htmlFor={ `checkbox-${ filter.value }` }
								       dangerouslySetInnerHTML={ { __html: filter.name } }/>
							</div>
						</div>
					);
				} ) }
				{ this.state.date === 'range' && (<DateRangeFilterMoment/>
				) }
			</div>
		);
	}

	getChronologicalFilters() {
		const chronologicalFilters = [
			{
				name   : 'Chronologically',
				value  : 'chronologically',
				checked: this.state.isChronological
			}, {
				name   : 'Popularity',
				value  : 'popularity',
				checked: !this.state.isChronological
			}
		];
		return (<div>
				<hr className={ 'category-divider' }/>
				<div className={ 'filter-heading-container' }>
					<h3 className="filter-heading">Sort By</h3>
					<i
						className={ `fa-solid fa-chevron-${ this.state.showChronologicalFilters
						                                    ? 'up'
						                                    : 'down' } filter-toggle-icon` }
						onClick={ this.toggleChronologicalFilter }
					/>
				</div>
				{ this.state.showChronologicalFilters && chronologicalFilters.map( ( filter, index ) => {
					return (<div key={ index }
					             className="filter-checkbox-container"
					             onClick={ this.toggleChronologicalPopularFilter }>
							<input type="radio"
							       id={ `checkbox-${ filter.value }` }
							       className={ `custom-checkbox` }
							       checked={ filter.checked }
							/>
							<label htmlFor={ `checkbox-${ filter.value }` }
							       dangerouslySetInnerHTML={ { __html: filter.name } }/>
						</div>
					);
				} ) }
			</div>
		);
	}

	getSearch() {
		return (<div>
				<hr className={ 'category-divider' }/>
				<div className={ 'filter-heading-container' }>
					<h3 className="filter-heading">Search</h3>
				</div>
				<input
					type="search"
					id="search"
					name="search"
					className="search-input form-control"
					placeholder="Filter by keyword"
					value={ this.state.searchTerm }
					onChange={ this.handleSearchChange }
				/>
			</div>
		);
	}

	clearSearchFilters() {
		this.props.dispatch(clearSearchTerm());
		//Need to wait or else it tries to query old filters. At some point, the way fetchPosts is set up needs to be changed.
		this.debounceTimeout = setTimeout( () => {
			this.handleCheckboxChange(this.getTopLevelCategoryDetails( this.props.topLevelCategory).term_id, true);
		}, 500 ); // 1000ms = 1 second

		this.setState({
			showDateFilters         : false,
			showChronologicalFilters: true,
			isChronological         : true,
			date                    : 'all',
			searchTerm              : '',
			showSubCategories       : true
		});
	}

	getClearFilters() {
		return (<div>
				<button 
					type="button" 
					className="text-button remove-filter-button" 
					name="Clear all search filters"
					onClick={ this.clearSearchFilters }
				>
					<i className="fa-regular fa-circle-xmark"></i>Clear All
				</button>
			</div>
		);
	}

	render() {
		return (<div>
				{/* The Filter Options button should be outside of the filter-side-bar */ }


				{/* The Filter Overlay that shows the filters in a popup on mobile */ }
				{ this.props.filterVisible && (<div className="filter-overlay">
						<div className="filter-popup">

							<div className="filter-heading-container">
								<h2 className="filter-heading">Categories</h2>
								<button onClick={ this.props.toggleFilters }
								        className="close-button">Close
								</button>
							</div>
							<p className={ 'category-description' }>
								Please select the category / subcategory you
								want to explore
							</p>
							{ this.renderMainCategories() }
							{ this.getDateFilters() }
							{ this.getSearch() }
							<button onClick={ this.props.toggleFilters }
							        className="done-button">Done
							</button>
						</div>
					</div>
				) }

				{/* The Sidebar that shows filters on larger screens */ }
				<div className="filter-side-bar-desktop">
					<div className="filter-heading-container">
						<h2 className="filter-heading">Categories</h2>
					</div>
					<p className={ 'category-description' }>
						Please select the category / subcategory you want to
						explore
					</p>
					{ this.renderMainCategories() }
					{ this.getDateFilters() }
					{ this.getSearch() }
					{ this.getClearFilters() }
				</div>
			</div>
		);
	}

}

function mapStateToProps( { dateRange, loading } ) {
	return { dateRange, loading };
}

export default connect( mapStateToProps )( withRouter( FilterSideBar ) );
